import { HourlyUsageLog, HourlyUsageLogs } from '@/service/llm/usage-logs/type';
import { formatAPIKey } from '@/utils';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';

export const columns: ColumnDef<HourlyUsageLog>[] = [
  {
    accessorKey: 'timestamp_hour',
    header: 'Timestamp',
    cell: ({ row }) => {
      return (
        <span>
          {dayjs(row.getValue('timestamp_hour')).format('DD MMM, HH:mm')}
        </span>
      );
    },
    size: 110,
  },
  {
    accessorKey: 'count',
    header: () => <div className="text-right">Count Request</div>,
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {row.getValue('count')?.toLocaleString()}
        </div>
      );
    },
    size: 100,
  },
  {
    accessorKey: 'total_prompt_usage',
    header: () => <div className="text-right">Total prompt usage</div>,
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {row.getValue('total_prompt_usage')?.toLocaleString()}
        </div>
      );
    },
    size: 100,
  },
  {
    accessorKey: 'total_completion_usage',
    header: () => <div className="text-right">Total completion usage</div>,
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {row.getValue('total_completion_usage')?.toLocaleString()}
        </div>
      );
    },
    size: 100,
  },
  {
    accessorKey: 'average_time_to_complete',
    header: () => <div className="text-right">Average time</div>,
    size: 100,
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {row.getValue('average_time_to_complete')?.toLocaleString()}
        </div>
      );
    },
  },
];
